import React from "react";
import { useSelector } from "react-redux";
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
// import "react-image-gallery/styles/scss/image-gallery.scss";

export default function ViewDetailsImageGalery() {

  const imagenames = useSelector(state => state.showRefState.selectedReferenceData);
  let photos = []

  Object.entries(imagenames).map(([key, value]) => {
    if(key.includes("image")){
        photos.push(
            {
              original: process.env.REACT_APP_EXPRESS_SERVER + '/ImagesForPDF/' + imagenames.image1.substring(imagenames.image1.lastIndexOf('-') + 1,imagenames.image1.lastIndexOf('.')) + '/' + value,
              thumbnail: process.env.REACT_APP_EXPRESS_SERVER + '/ImagesForPDF/' + imagenames.image1.substring(imagenames.image1.lastIndexOf('-') + 1,imagenames.image1.lastIndexOf('.')) + '/' + value,
              },
        )
    }
    return ''
  })
      return (
        <div> 
        <ImageGallery items={photos} /> 
        </div>
      )
    
  }

  // const imagenames = useSelector(state => state.showRefState.selectedReferenceData);
  // let photos = []


  // Object.entries(imagenames).map(([key, value]) => {
  //   if(key.includes("image")){
  //       photos.push(
  //           {
  //               src: '/ImagesForPDF/' + imagenames.image1.substring(imagenames.image1.lastIndexOf('-') + 1,imagenames.image1.lastIndexOf('.')) + '/' + value,
  //               width: 3,
  //               height: 2
  //             },
  //       )
  //   }

  // })

  // const [currentImage, setCurrentImage] = useState(0);
  // const [viewerIsOpen, setViewerIsOpen] = useState(false);

  // // const openLightbox = (index) => {
  // //   setCurrentImage(index);
  // //   setViewerIsOpen(true);
  // // };
  // // useEffect(() => {
  // //   setCurrentImage(0);
  // // })


  // const openLightbox = useCallback((event, { photo, index }) => {
  //   setCurrentImage(index);
  //   setViewerIsOpen(true);
  // }, []);

  // const closeLightbox = () => {
  //   setCurrentImage(0);
  //   setViewerIsOpen(false);
  // };

  // return (
  //   <div>
  //     <Gallery photos={photos} onClick={openLightbox} />
  //     <ModalGateway>
  //       {viewerIsOpen ? (
  //         <Modal onClose={closeLightbox}>
  //           <Carousel
  //             currentIndex={currentImage}
  //             views={photos.map(x => ({
  //               ...x,
  //               srcset: x.srcSet,
  //               caption: x.title
  //             }))}
  //           />
  //         </Modal>
  //       ) : null}
  //     </ModalGateway>
  //   </div>
  // );
// }

